module.exports = __webpack_public_path__ + "img/SMIUsers.8355b63d.png";